export default "__VITE_ASSET__Xh8liAQP__"